import React, { FC, useCallback, useRef } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { createUseStyles } from 'src/theming';
import SignatureCanvas from 'react-signature-canvas';
import useWindowDimensions from 'src/hooks/useWindowDimensions';

const useStyles = createUseStyles({
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
  formControl: {
    marginBottom: '16px !important',
  },
  canvas: {
    border: '1px solid gray',
    marginBottom: 10,
  },
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    overflowX: 'hidden',
  },
  warranty: {
    marginTop: 15,
    fontSize: 11,
  },
  tuto: {
    marginTop: 24,
    fontSize: 13,
    fontWeight: 'bold',
  },
});

interface Props {
  open: boolean;
  mainText?: any;
  footerText?: any;
  onClose: () => void;
  onValidate: (signature: string) => void;
}

const SignatureDialog: FC<Props> = ({ footerText, mainText, open, onClose, onValidate }) => {
  const classes = useStyles();
  const signatureRef = useRef<SignatureCanvas>();
  const screen = useWindowDimensions();

  const handleValidate = () => {
    if (signatureRef.current) {
      onValidate(signatureRef.current.getTrimmedCanvas().toDataURL('image/png'));
    }
  };

  const isFullscreen = useCallback(() => screen.width < 576, [screen]);

  return (
    <Dialog fullScreen={isFullscreen()} onClose={onClose} scroll='paper' open={open}>
      <DialogTitle>Apposez votre signature</DialogTitle>

      <DialogContent className={classes.container}>
        {mainText && <div>{mainText}</div>}

        <div className={classes.tuto}>Cliquez et maintenez le clic enfoncé tout en déplaçant votre curseur.</div>

        <SignatureCanvas ref={signatureRef} canvasProps={{ width: 400, height: 400, className: classes.canvas }} />

        {footerText && <div className={classes.warranty}> {footerText}</div>}
      </DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' color='primary' onClick={handleValidate}>
          Valider
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SignatureDialog;
